"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuotationBox = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var Icon_1 = require("../Icon");
var Spacer_1 = require("../Spacer");
var TextFormatter_1 = require("../TextFormatter");
require("./quotationBox.css");
var QuotationBox = function (_a) {
    var label = _a.label, icon = _a.icon, topInfo = _a.topInfo, overInfo = _a.overInfo, isNews = _a.isNews, onClick = _a.onClick;
    function renderTopRibbon() {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('quotation-box-top-ribbon', isNews || typeof topInfo === 'undefined' ? 'hidden' : '') }, { children: (0, jsx_runtime_1.jsx)(TextFormatter_1.TextFormatter, __assign({ fontSize: "base", fontWeight: "bold", borderless: true }, { children: isNews || typeof topInfo === 'undefined' ? '' : topInfo })) })));
    }
    function renderOverInfo() {
        if (typeof overInfo === 'undefined') {
            return null;
        }
        return (0, jsx_runtime_1.jsx)("div", __assign({ className: "quotation-box-over-info" }, { children: overInfo }));
    }
    function renderNews() {
        if (!isNews) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "quotation-box-news" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: "icon_new", size: "xl", theme: "primary" }) })));
    }
    function renderContent() {
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "quotation-box-content" }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: icon, theme: "primary", size: "xxxl" }), (0, jsx_runtime_1.jsx)(Spacer_1.Spacer, { height: 1 }), (0, jsx_runtime_1.jsx)(TextFormatter_1.TextFormatter, __assign({ fontSize: "base", fontWeight: "bold", textAlign: "center", borderless: true }, { children: label }))] })));
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "quotation-box", onClick: onClick }, { children: [renderTopRibbon(), renderContent(), renderOverInfo(), renderNews()] })));
};
exports.QuotationBox = QuotationBox;
//# sourceMappingURL=QuotationBox.js.map